// extracted by mini-css-extract-plugin
export default {"magnetWrap":"LeadMagnet_magnetWrap__UOxRX","magnet":"LeadMagnet_magnet__Nq9JV","magnetLink":"LeadMagnet_magnetLink__QuV4p"};